import React from "react";

/**
 * Renders a cover image that fully fills its box WITHOUT cropping.
 *
 * Technique: the full image is shown with `object-fit: contain` (so nothing is
 * cut off), sitting on top of a blurred, zoomed copy of the same image that
 * fills any gaps left by mismatched aspect ratios. When the image ratio matches
 * the box, the backdrop is simply hidden behind the foreground — no downside.
 *
 * Sizing (width / height / aspectRatio / borderRadius) is passed via `style`.
 * `imgClassName` is applied to the foreground <img> so existing hover styles
 * (e.g. scale-on-hover) keep working.
 */
const BlogCover = ({
  src,
  alt = "",
  onError,
  style = {},
  imgClassName,
  imgStyle = {},
}) => (
  <div
    style={{
      position: "relative",
      overflow: "hidden",
      backgroundColor: "#ECEAE2",
      ...style,
    }}
  >
    {/* blurred backdrop — fills the box, hidden behind the real image */}
    <img
      src={src}
      alt=""
      aria-hidden="true"
      onError={onError}
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        filter: "blur(20px)",
        transform: "scale(1.1)",
      }}
    />
    {/* foreground — the full, uncropped image */}
    <img
      src={src}
      alt={alt}
      onError={onError}
      className={imgClassName}
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        objectFit: "contain",
        display: "block",
        ...imgStyle,
      }}
    />
  </div>
);

export default BlogCover;
